export default function propsProvider(props) {
  /*
      - To only list utilized props
      - Wrapping utilized props on each view
  */
  const { intl, addressList, showAddressInMap, history, productInfo } = props;
  return { intl, addressList, showAddressInMap, history, productInfo };
}
